<div class="panel">
  <div class="border-b border-gray-200">
    <div class="px-8 h-20 items-center flex gap-3">
      <!-- The list heading is the button that opens its menu (TW-PANEL-07): named by its text, Enter and Space native. -->
      <button
        type="button"
        class="bg-transparent border-0 p-0 [font:inherit] text-inherit text-left cursor-pointer"
        appDPMessagesContextMenu
        (appDPContextMenuOpened)="contextMenuOpened = $event"
        (appDPContextMenuFilterChanged)="selectFilter($event)"
        aria-haspopup="menu"
        [attr.aria-expanded]="!!contextMenuOpened"
      >
        <app-dropdown-label [collapsed]="!contextMenuOpened">
          {{ selectedFilter | titleByMessagesFilter }}
        </app-dropdown-label>
      </button>

      <div class="grow"></div>

      @if (selectedTab !== 'folders') {
        <app-context-menu-state-indicator
          svgIcon="filters"
          appMessagesListContextMenu
          [appMessagesListContextMenuWithAdvancedSearch]="true"
          [appMessagesListContextMenuWithToSort]="
            selectedFilter !== 'bulk' &&
            selectedFilter !== 'spam' &&
            selectedFilter !== 'inbox' &&
            selectedFilter !== 'other_mail'
          "
          [appMessagesListContextMenuWithFromSort]="selectedFilter !== 'sent' && selectedFilter !== 'draft' && selectedFilter !== 'scheduled'"
          [appMessagesListContextMenuWithUnreadFilter]="selectedFilter !== 'sent' && selectedFilter !== 'draft' && selectedFilter !== 'scheduled'"
          [appMessagesListContextMenuWithThreadedView]="selectedFilter === 'inbox' || selectedFilter === 'sent'"
          />
      }
      @if (selectedTab === 'folders') {
        <app-context-menu-state-indicator
          svgIcon="filters"
          appMessagesFoldersListContextMenu
          [appMessagesFoldersListContextMenuWithAdvancedSearch]="true"
          />
      }

      <app-search-state-indicator
        [applied]="isSearchApplied()"
        (clear)="clearSearch()"
      >
        <app-icon
          class="max-w-8 max-h-8 text-gray-500 cursor-pointer items-center"
          name="search-small"
          stchPopover
          stchPopoverPlacement="bottomRight"
          stchPopoverTrigger="click"
          [stchPopoverContent]="searchPopover"
          [stchPopoverFallbackPlacements]="[]"
          [stchPopoverShowUntil]="popoverClose"
        />
      </app-search-state-indicator>
    </div>
    @if (listState === 'tabs') {
      <app-tabs
        class="panel-heading-tabs"
        [values]="tabs"
        [(value)]="selectedTab"
        />
    }
  </div>

  @if (selectedTab === 'messages' && selectedFilter === 'inbox') {
    <app-quick-form
      class="panel-quick-form" trigger="button" [collapseKey]="selectedFilter"
      placeholder="Add New Message"
    >
      <app-message-quick-form
        [showMore]="true"
        [destinationTenantId]="mailboxTenantScope?.effectiveTenantId() ?? undefined"
        (more)="handleNewMessage($event)"
      />
    </app-quick-form>
  }

    @if (selectedTab === 'folders' && creationAllowed()) {
      <app-quick-form
        class="panel-quick-form" trigger="button" [collapseKey]="selectedFilter"
        placeholder="Add New Folder"
      >
      <app-message-folder-quick-form [showMore]="true" (more)="handleNewMessageFolder($event)" />
      </app-quick-form>
    }

    <div class="panel-list border-t border-gray-200">
      @if (selectedTab !== 'folders' && messagesFilters) {
        <app-messages2-list
          [filters]="messagesFilters"
          [showLocationBadge]="isAdvancedSearchApplied()"
          (openMessage)="openMessage($event.id)"
          (doubleClickMessage)="openMessage($event.id)"
          (doubleClickThreadMessage)="openMessage($event.id)"
          />
      }

      @if (selectedTab === 'folders') {
        <app-message-folders-list
          [filters]="foldersFilters"
          (openMessage)="openMessageInModal($event)"
          (openFolder)="openFolder($event.id)"
          (doubleClickFolder)="openFolder($event.id)"
          />
      }
    </div>
  </div>

<ng-template #searchPopover>
  <app-mail-search-popover
    [width]="600"
    (onSearch)="handleSearch()"
    (onCancel)="handleCancel()"
  />
</ng-template>
